import Edit from "./Edit";
import { withRouter } from "react-router-dom";

export default withRouter(Edit);
